import React, { useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody"; 
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Box, Button, Grid, InputAdornment, makeStyles, TextField } from "@material-ui/core/";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import DnerhsApi, { CancelToken } from "../../../api/DnerhsApi";
import { useParams } from "react-router-dom";
import history from "../../../utils/History";
import Alert from "../../../components/Alert";
import ResponseUtils from "../../../utils/ResponseUtils";
import ListIcon from '@material-ui/icons/List';
import VisibilityIcon from "@material-ui/icons/Visibility";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(),
  },
  filtersBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
  },
  searchInput: {
    minWidth: 320,
    maxWidth: 560,
    flex: '1 1 360px',
  },
  counter: {
    color: theme.palette.text.secondary,
    fontSize: 13,
  },
  cronogramaCell: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
}));

const List = () => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalElements, setTotalElements] = useState(3);
  const [rows, setRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const params = useParams();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      loadData({ page, rowsPerPage, search: searchTerm });
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [page, rowsPerPage, searchTerm]);

  const loadData = async ({ page = 0, rowsPerPage = 10, search = "" }) => {
    let source = CancelToken.source();
    try {
      // Endpoint actualizado para usar el nuevo endpoint específico de establecimientos
      let url = `/convenios/establecimientos/${params.institucionEstablecimientoId}/practicas/aprobadas/page/?page=${page}&pageSize=${rowsPerPage}&search=${encodeURIComponent(search.trim())}`;

      const response = await DnerhsApi(url, {
        cancelToken: source.token,
      });
      const { content, totalElements } = response.data;
      console.log(response.data)
      setRows(content || []);
      setTotalElements(totalElements);
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setRows([]);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    let rowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(rowsPerPage);
    setPage(0);
    setRows([]);
  };

  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error"
    })
  }

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0);
  };


  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Paper>
          <Box p={1}>
            <Typography
              variant="h5"
              color="primary"
              align="center"
              className={classes.title}
            >
              Prácticas
            </Typography>
            <Box className={classes.filtersBar}>
              <TextField
                className={classes.searchInput}
                value={searchTerm}
                onChange={handleSearchChange}
                variant="outlined"
                size="small"
                placeholder="Buscar por Nro. cronograma, institucion, carrera, materia, curso, semestre o estado"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
              <span className={classes.counter}>
                Mostrando {rows.length} de {totalElements} practicas
              </span>
            </Box>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Nro. Cronograma</TableCell>
                  <TableCell align="left">Institución Formadora</TableCell>
                  <TableCell align="left">Carrera</TableCell>
                  <TableCell align="left">Materia</TableCell>
                  <TableCell align="left">Curso</TableCell>
                  <TableCell align="left">Semestre</TableCell>
                  <TableCell align="left">Estado</TableCell>
                  <TableCell align="left">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left" className={classes.cronogramaCell}>
                      {row.id}
                    </TableCell>
                    <TableCell align="left">
                      {row.convenio.institucionFormadora.institucion}
                    </TableCell>
                    <TableCell align="left">
                      {(row.convenioCarrera?.carreraPrograma.descripcion==="Postgrado"? "Postgrado - " + row.convenioCarrera.nombrePostgrado.descripcion:  row.convenioCarrera.carreraPrograma.descripcion)}

                    </TableCell>
                    <TableCell align="left">
                      {row.materia}
                    </TableCell>
                    <TableCell align="left">
                      {row.curso}
                    </TableCell>
                    <TableCell align="left">
                      {row.semestre}
                    </TableCell>
                    <TableCell align="left">
                      {row.estado}
                    </TableCell>
                    <TableCell align="left">                   
                      <>                  
                        <Tooltip title="Confirmar Asistencias" aria-label="Ver">
                          <IconButton
                            size="small"
                            aria-label="confirmar asistencias"
                            color="primary"
                            onClick={() => history.push({
                              pathname: `/convenios/confirmacionesPracticasEstablecimientos/confirmar/${row.id}`,
                              state: {
                                readOnly: true
                              }
                            })}
                          >
                            {(row.estado === "Práctica cronograma finalizada")? <VisibilityIcon /> :  <ListIcon /> }
                          </IconButton>
                        </Tooltip>
                      </>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 15, 20]}
                    colSpan={8}
                    count={totalElements}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { "aria-label": "Registros por página" },
                      native: false,
                    }}
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} de ${count}`
                    }
                    labelRowsPerPage="Registros por página"
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item className={classes.button}>
                <Button
                  variant="contained"
                  color="default"
                  onClick={() => history.goBack()}
                >
                  Atrás
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default List;
